export const getTravelSsInsurance = (state) => state.travelSs;
